import React from 'react';
import {
  BlockAlert,
  PaymentDetail,
  PaymentDetails,
  PaymentTitle,
  PaymentTotal,
  FixedWithContainer,
  ContainerButtons,
  DetailSection,
  ContainerAlerts
} from './styled';
import TextHelper from '@/core/helpers/TextHelper';
import DateHelpers from '@/core/helpers/DateHelper';
import { FeeTag } from '@/presentation/modules/payments/modules/PayOnline/PayOnline.styled';
import iconProntoPago from '../../../../../assets/icons/payments/iconPorcentageProntoPago.svg';
import warningAlertIcon from '../../../../../assets/icons/warning-alert.svg';
import {
  TornEdgeBottom,
  TornEdgeTop
} from '../../modules/PaymentDetails/PaymentDetails.styled';
import { SubsectionHeader } from '@/presentation/reusables/SectionHeader';
import Button from '@/presentation/reusables/Button';
import Processing from '@/presentation/components/Processing';
import ModalMessageFullCycle from '@/presentation/modules/procedures/modules/requests/FullCycleDiscount/components/ModalMessageFullCycle';
import ErrorMessage from '@/presentation/components/Error';
import { PaymentStatus, PaymentType } from '../../constants';
import PaymentContainer from '../ContainerPayments';
import { formatAmount } from '../../modules/PayOnline/helpers';
import imgWarning from '@/assets/illustrations/warning.svg';
import MyModal from '@/presentation/modules/procedures/components/Modals/MyModal';

const PaymentsView = ({
  data,
  handleBack,
  handlerRedirect,
  handleGoPSE,
  handleDonwloadVoucher,
  isLoadingPaymentVoluchers,
  handlerDeactivateDiscount,
  isLoadDeactivate,
  showModalDeactivateBenefit,
  optionMessage,
  isLoadDownloadVoucher,
  showModalPendingIssuance,
  isNewLocation
}: any) => {
  if (!data?.periodDesc) {
    return (
      <PaymentContainer>
        <FixedWithContainer>
          <SubsectionHeader title="Detalle de pago" onClick={handleBack} />
          <ErrorMessage />
        </FixedWithContainer>
      </PaymentContainer>
    );
  }

  const {
    name,
    amount,
    status,
    paymentType,
    hasDiscountProntoPago,
    dueDate,
    dateCreate,
    datePayment,
    billingDate,
    recharge,
    periodDesc,
    amountToPay,
    discountProntoPago,
    discountCicloCompleto,
    discountBene,
    isFullCycleDiscount,
    exonerationDatePSE
  } = data;
  let tag;

  switch (status) {
    case 'Por vencer':
      tag = 'default';
      break;
    case 'Vencido':
      tag = 'expired';
      break;
    case 'Pagado':
      tag = 'payed';
      break;
    default:
      tag = '';
  }

  return (
    <>
      <PaymentContainer>
        <SubsectionHeader title="Detalle de pago" onClick={handleBack} />
        <DetailSection>
          <PaymentDetails>
            <TornEdgeTop />

            <PaymentTitle>
              <div className="title">
                <span>{name}</span>
                {status !== 'No pagado' &&
                  (status === PaymentStatus.paid ||
                    paymentType?.id !== PaymentType.TRAMITES) && (
                    <FeeTag className={tag}>{status}</FeeTag>
                  )}
              </div>
              <div className="item">
                <span>Tipo</span>
                <span>{TextHelper.capitalize(paymentType?.desc)}</span>
              </div>
              <div className="item">
                <span>Ciclo</span>
                <span>{DateHelpers.periodToName(periodDesc)}</span>
              </div>
            </PaymentTitle>
            <hr />

            <PaymentDetail>
              {paymentType?.id !== PaymentType.TRAMITES && (
                <>
                  {status !== PaymentStatus.paid ? (
                    <div className="item">
                      <span>Vencimiento</span>
                      <span>{DateHelpers.formatDateExtended2(dueDate)}</span>
                    </div>
                  ) : (
                    <>
                      <div className="item">
                        <span>Vencimiento</span>
                        <span>{DateHelpers.formatDateExtended2(dueDate)}</span>
                      </div>
                      <div className="item">
                        <span>Fecha de pago</span>
                        <span>
                          {datePayment
                            ? DateHelpers.formatDateExtended2(datePayment)
                            : ' -'}
                        </span>
                      </div>
                    </>
                  )}
                </>
              )}

              {paymentType?.id === PaymentType.TRAMITES && (
                <>
                  {status !== PaymentStatus.paid ? (
                    <>
                      <div className="item">
                        <span>Fecha de creación</span>
                        <span>
                          {DateHelpers.formatDateExtended2(dateCreate)}
                        </span>
                      </div>
                      <div className="item">
                        <span>Vencimiento</span>
                        <span>{DateHelpers.formatDateExtended2(dueDate)}</span>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="item">
                        <span>Fecha de creación</span>
                        <span>
                          {DateHelpers.formatDateExtended2(dateCreate)}
                        </span>
                      </div>
                      <div className="item">
                        <span>Vencimiento</span>
                        <span>{DateHelpers.formatDateExtended2(dueDate)}</span>
                      </div>
                      <div className="item">
                        <span>Fecha de pago</span>
                        <span>
                          {datePayment
                            ? DateHelpers.formatDateExtended2(datePayment)
                            : ' -'}
                        </span>
                      </div>
                    </>
                  )}
                </>
              )}

              <hr className="divider-secondary" />
              <div className="item">
                <span className="subtotal-title">Subtotal</span>
                <span>S/ {amount}</span>
              </div>
              {paymentType?.id === PaymentType.PENSIONES &&
                discountBene > 0 && (
                  <div className="discount-item">
                    <span>
                      <div className="discount-title">Descuento beneficio</div>
                      <div className="discount-subtitle">
                        Aplicado por conceptos de becas, convenios y otros
                        beneficios.
                      </div>
                    </span>
                    <span className="discount-percentage">
                      -S/ {` ${discountBene}`}
                    </span>
                  </div>
                )}
              {paymentType?.id === PaymentType.PENSIONES &&
                hasDiscountProntoPago &&
                status !== PaymentStatus.paid && (
                  <div className="discount-item">
                    <span>
                      <div className="discount-title">
                        Descuento pronto pago{' '}
                        <img src={iconProntoPago} alt="iconProntoPago" />
                      </div>
                      <div className="discount-subtitle">
                        Hasta 1 día antes del vencimiento y el monto depende del
                        banco.
                      </div>
                    </span>
                    <span className="discount-percentage">Hasta 5% </span>
                  </div>
                )}
              {discountProntoPago > 0 && (
                <div className="discount-item">
                  <span>
                    <div className="discount-title">Descuento pronto pago</div>
                  </span>
                  <span className="discount-percentage">
                    -S/ {` ${discountProntoPago}`}
                  </span>
                </div>
              )}
              {(paymentType?.id === PaymentType.PENSIONES ||
                isFullCycleDiscount) &&
                discountCicloCompleto > 0 && (
                  <div className="discount-item">
                    <span>
                      <div className="discount-title">
                        {status !== PaymentStatus.paid
                          ? 'Descuento beneficio'
                          : 'Descuento ciclo completo'}
                      </div>
                      {status !== PaymentStatus.paid && (
                        <div className="discount-subtitle">
                          10% de descuento por pago de todas las cuotas del
                          ciclo antes del vencimiento.
                        </div>
                      )}
                    </span>
                    <span className="discount-percentage">
                      -S/{' '}
                      {typeof discountCicloCompleto === 'number'
                        ? discountCicloCompleto.toFixed(2)
                        : discountCicloCompleto}
                    </span>
                  </div>
                )}
              {paymentType?.id === PaymentType.PENSIONES && recharge > 0 && (
                <div className="recharge-item">
                  <span>
                    <div className="recharge-title">Mora</div>
                    {status !== PaymentStatus.paid && (
                      <div className="recharge-subtitle">
                        El monto aumenta cada día. Paga a tiempo para asegurar
                        tu matrícula en el próximo ciclo.
                      </div>
                    )}
                  </span>
                  <span className="recharge-value">+S/ {` ${recharge}`}</span>
                </div>
              )}
            </PaymentDetail>
            <hr className="divider-primary" />
            <PaymentTotal>
              {status !== PaymentStatus.paid ? (
                <span>Total a pagar</span>
              ) : (
                <span>Total pagado</span>
              )}
              <span>S/ {formatAmount(amountToPay)}</span>
            </PaymentTotal>
            <TornEdgeBottom />
          </PaymentDetails>
          <ContainerButtons>
            {status !== PaymentStatus.paid && (
              <Button
                onClick={() => handlerRedirect('/pagos/opciones-pago')}
                text="Opciones de pago"
              />
            )}
            {status !== PaymentStatus.paid && isFullCycleDiscount && (
              <Button
                outlined
                onClick={() => handlerDeactivateDiscount()}
                text="Desactivar descuento"
              />
            )}
            {status === PaymentStatus.paid && (
              <Button
                onClick={() => handleDonwloadVoucher()}
                text=" Descargar comprobante"
                disabled={
                  Boolean(isLoadingPaymentVoluchers) || Boolean(!billingDate)
                }
              />
            )}
          </ContainerButtons>
          <ContainerAlerts>
            {exonerationDatePSE &&
              status !== PaymentStatus.paid &&
              !isNewLocation && (
                <BlockAlert>
                  <span>
                    <img src={warningAlertIcon} alt="warningAlertIcon" />
                  </span>
                  <span>
                    Si ya tienes otro seguro de salud vigente, valídalo hasta el{' '}
                    {DateHelpers.formatDateWhitFullMonth(exonerationDatePSE)}{' '}
                    para anular este pago.&nbsp;&nbsp;
                    <a
                      data-testid="cmp-link-pse-procedure"
                      onClick={() => handleGoPSE()}
                      aria-hidden="true"
                      style={{
                        color: '#5b36f2',
                        textDecoration: 'underline',
                        cursor: 'pointer'
                      }}
                    >
                      Valida tu seguro ahora.
                    </a>
                  </span>
                </BlockAlert>
              )}
            {isFullCycleDiscount && status !== PaymentStatus.paid && (
              <BlockAlert>
                <span>
                  <img src={warningAlertIcon} alt="warningAlertIcon" />
                </span>
                <span style={{ color: '#161D1F', alignContent: 'center' }}>
                  Al desactivar el descuento, las cuotas se pagarán por
                  separado.
                </span>
              </BlockAlert>
            )}
            {(paymentType?.id === PaymentType.MATRICULA ||
              exonerationDatePSE) &&
              status !== PaymentStatus.paid && (
                <BlockAlert>
                  <span>
                    <img src={warningAlertIcon} alt="warningAlertIcon" />
                  </span>
                  <span>Si decides no matricularte, se anulará este pago.</span>
                </BlockAlert>
              )}
            {status === PaymentStatus.paid && (
              <BlockAlert>
                <span>
                  <img src={warningAlertIcon} alt="warningAlertIcon" />
                </span>
                <span>
                  Se podrían emitir 1 o 2 comprobantes al descargar, según los
                  montos pagados.
                </span>
              </BlockAlert>
            )}
          </ContainerAlerts>
        </DetailSection>
      </PaymentContainer>
      <ModalMessageFullCycle
        showModal={showModalDeactivateBenefit}
        optionMessage={optionMessage}
        handlerBack={handleBack}
      />
      <MyModal
        show={
          showModalPendingIssuance?.showPendingIssuance &&
          !isLoadDownloadVoucher
        }
        img={imgWarning}
        data={{
          title: 'Estamos emitiendo tu comprobante',
          description: 'Puede tardar hasta 24 horas para la descarga'
        }}
        handlerClick={() =>
          showModalPendingIssuance?.setShowPendingIssuance?.(false) ??
          (() => {})
        }
        handlerClose={() =>
          showModalPendingIssuance?.setShowPendingIssuance?.(false) ??
          (() => {})
        }
      />
      <Processing
        isOpen={Boolean(isLoadDeactivate) || Boolean(isLoadDownloadVoucher)}
      />
    </>
  );
};

export default PaymentsView;
